<ng-template #itemTemplate let-item>
	{{ item.firstName }} {{ item.lastName }}
</ng-template>
<ng-template #allTemplate let-item> All </ng-template>

<app-dropdown
	(onSelect)="onSelect($event)"
	[placeholder]="placeholder"
	[label]="label"
	[itemGroups]="[
		{ items: ['All'], template: allTemplate },
		{ items: list, template: itemTemplate },
	]"
	[ngModel]="selectedDropDownValue"
	name="dual-dropdown-1"
>
</app-dropdown>
